import { HTTP_GET, HTTP_POST, HTTP_PUT, WebApiRequest } from "tools/webservice";
import employeeApi from "apis/employee";
import * as employeeRoles from "typeConstants/employeeRoles";
import { createRequestCoalescer } from "tools/requestCoalescer";

const nextNotificationCoalescer = createRequestCoalescer();
const activeRequest = { current: true };

// move-to-map
export const moveToMap = (payload, successCallback, errorCallback, mountedRef) => WebApiRequest({
  method: HTTP_POST,
  endpoint: `/scheduling-assistant/move-to-map`,
  payload,
  successCallback,
  errorCallback,
  mountedRef,
});

export const getNextCase = (payload, successCallback, errorCallback, mountedRef) => WebApiRequest({
  method: HTTP_POST,
  endpoint: `/scheduling-assistant/next-case`,
  payload,
  successCallback,
  errorCallback,
  mountedRef,
});

export const sendCaseToUser = (payload, successCallback, errorCallback, mountedRef) => WebApiRequest({
  method: HTTP_POST,
  endpoint: `/scheduling-assistant/send-case-to-user`,
  payload,
  successCallback,
  errorCallback,
  mountedRef,
});

export const leaveCase = (payload, successCallback, errorCallback, mountedRef) => WebApiRequest({
  method: HTTP_POST,
  endpoint: `/scheduling-assistant/leave-case`,
  payload,
  successCallback,
  errorCallback,
  mountedRef,
});

export const getNextNotification = (payload, successCallback, errorCallback, mountedRef) => WebApiRequest({
  method: HTTP_POST,
  endpoint: `/scheduling-assistant/next-notification`,
  payload,
  successCallback,
  errorCallback,
  mountedRef,
});

export const getNextNotificationCoalesced = (controlNumber, successCallback, errorCallback) => nextNotificationCoalescer.run(
  controlNumber,
  (resolve, reject) => getNextNotification({ ControlNumber: controlNumber }, resolve, reject, activeRequest),
  successCallback,
  errorCallback,
);

export const refreshNextNotification = (controlNumber, successCallback, errorCallback) => nextNotificationCoalescer.refresh(
  controlNumber,
  (resolve, reject) => getNextNotification({ ControlNumber: controlNumber }, resolve, reject, activeRequest),
  successCallback,
  errorCallback,
);

export const invalidateNextNotification = (controlNumber) => {
  if (controlNumber) {
    nextNotificationCoalescer.invalidate(controlNumber);
  }
};

export const getSchedulingManagers = (successCallback, mountedRef) => WebApiRequest({
  method: HTTP_GET, 
  endpoint: employeeApi.getEmployeesByRoles([employeeRoles.CUSTOMER_EXPERIENCE_MANAGER]),
  successCallback,
  mountedRef
  });

export const getSchedulingAssistants = (successCallback, mountedRef) => WebApiRequest({
  method: HTTP_GET, 
  endpoint: employeeApi.getEmployeesByRoles([employeeRoles.CUSTOMER_EXPERIENCE_REP, employeeRoles.CUSTOMER_EXPERIENCE_MANAGER]),
  successCallback,
  mountedRef
});

export const moveToTopOfSchedulingQueue = (controlIdNumber, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_PUT,
  endpoint: `/scheduling-assistant/cases/${controlIdNumber}/scheduling-queue/move-case-to-top`,
  successCallback,
  mountedRef,
});

export const moveToScheduling = (payload, successCallback, errorCallback, mountedRef) => WebApiRequest({
  method: HTTP_POST,
  endpoint: `/scheduling-assistant/cases/move-to-scheduling`,
  payload,
  successCallback,
  errorCallback,
  mountedRef,
});
